
module.exports = function (paths) {
    const FURTHER_REF = paths.FURTHER_REF
    return {
        test: /\.coffee$/,
        // loader: require('coffee-loader?sourceMap=true') // coffeeLoader('!sourceMap=true')
        use: [
            {
            loader: FURTHER_REF + 'coffee-loader',
            options: { sourceMap: true }
            }
        ],
        exclude: /node_modules/
    }
}



// WEBPACK FOOTER //
// ./src/technologies/coffee-script.js